document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  const lightingMenus = document.querySelectorAll('.lighting-nav-group');
  const closeLightingMenus = () => lightingMenus.forEach((item) => { item.open = false; });

  document.querySelectorAll('[data-language-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.form;
      if (!form) return;
      // Let Shopify resolve the same resource in the target locale. Do not build /fr/en URLs.
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) {
        const returnPath = form.dataset.returnPath || window.location.pathname;
        returnTo.value = returnPath === window.location.pathname
          ? `${returnPath}${window.location.search}`
          : returnPath;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  });

  document.addEventListener('pointerdown', (event) => {
    lightingMenus.forEach((item) => { if (!item.contains(event.target)) item.open = false; });
  });
  menu?.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeLightingMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || menuButton?.getAttribute('aria-expanded') === 'true') return;
    lightingMenus.forEach((item) => {
      if (!item.open) return;
      item.open = false;
      item.querySelector('summary')?.focus();
    });
  });

  if (menuButton && menu) {
    const mobileMenu = window.matchMedia('(max-width: 760px)');
    const setMenuState = (open) => {
      if (!open) closeLightingMenus();
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
      menu.classList.toggle('is-open', open);
      if (mobileMenu.matches) {
        menu.inert = !open;
        menu.setAttribute('aria-hidden', String(!open));
      } else {
        menu.inert = false;
        menu.removeAttribute('aria-hidden');
      }
    };

    setMenuState(false);
    const handleBreakpointChange = () => setMenuState(false);
    if (typeof mobileMenu.addEventListener === 'function') mobileMenu.addEventListener('change', handleBreakpointChange);
    else mobileMenu.addListener(handleBreakpointChange);

    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      setMenuState(!isOpen);
    });
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuState(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
        setMenuState(false);
        menuButton.focus();
      }
    });
  }

  const contactForm = document.getElementById('RomidrianContactForm');
  if (contactForm) {
    const params = new URLSearchParams(window.location.search);
    const subject = (params.get('objet') || '').slice(0, 300);
    const format = (params.get('format') || '').slice(0, 200);
    const subjectInput = contactForm.querySelector('[name="contact[subject]"]');
    const context = contactForm.querySelector('[data-contact-context]');
    const formatInput = contactForm.querySelector('[data-contact-format]');
    if (subject && subjectInput && !subjectInput.value) subjectInput.value = subject;
    if ((subject || format) && context) {
        context.textContent = [context.dataset.contextLabel, subject, format].filter(Boolean).join(' · ');
      context.hidden = false;
    }
    if (format && formatInput) {
      formatInput.value = format;
      formatInput.disabled = false;
    }
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const image = thumb.closest('.product-gallery')?.querySelector('[data-gallery-main] img');
      if (!image) return;
      image.src = thumb.dataset.image;
      image.alt = thumb.dataset.alt || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('thumb-active'));
      thumb.classList.add('thumb-active');
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const price = form.closest('.product-information')?.querySelector('[data-product-price]');
    const submit = form.querySelector('[data-add-button]');
    if (!variantSelect) return;

    const updateVariant = () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      if (!selected) return;
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (submit) {
        submit.disabled = selected.dataset.available !== 'true';
        const label = selected.dataset.available === 'true' ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
        submit.textContent = label;
      }
    };
    variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  });
});
